module.exports = __webpack_public_path__ + "img/slide6.8b3269e5.png";